import { PopReportsSport } from './models/pop-reports-sport';

export const SPORTS: PopReportsSport[] = [
    { id: 2, name: 'baseball', img: '/assets/img/icon-baseball.svg', alt: 'Baseball' },
    { id: 12, name: 'basketball', img: '/assets/img/icon-basketball.svg', alt: 'Basketball' },
    { id: 7, name: 'football', img: '/assets/img/icon-football.svg', alt: 'Football' },
    { id: 10, name: 'hockey', img: '/assets/img/icon-hockey.svg', alt: 'Hockey' },
    { id: -1, name: 'other', img: '/assets/img/icon-packs.svg', alt: 'Other' },
];